import { render } from "./new-password.vue?vue&type=template&id=e6be45e8&ts=true"
import script from "./new-password.vue?vue&type=script&lang=ts"
export * from "./new-password.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__